<template>
    <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M60 25.5415C55.221 21.3311 48.927 18.75 42 18.75C27.087 18.75 15 30.6241 15 45.2678C15 68.8393 45 95.3571 60 101.25C75 95.3571 105 68.8393 105 45.2678C105 30.6241 92.913 18.75 78 18.75C67.431 18.75 58.437 24.7931 54 33.4821M93 45.2687C93 37.1307 86.286 30.5366 78 30.5366L93 45.2687Z"
            :fill="color"
        />
        <path
            d="M60 25.5415C55.221 21.3311 48.927 18.75 42 18.75C27.087 18.75 15 30.6241 15 45.2678C15 68.8393 45 95.3571 60 101.25C75 95.3571 105 68.8393 105 45.2678C105 30.6241 92.913 18.75 78 18.75C67.431 18.75 58.437 24.7931 54 33.4821M93 45.2687C93 37.1307 86.286 30.5366 78 30.5366L93 45.2687Z"
            fill="url(#paint0_linear_20621_341935)"
            fill-opacity="0.8"
        />
        <path
            d="M60 25.5415C55.221 21.3311 48.927 18.75 42 18.75C27.087 18.75 15 30.6241 15 45.2678C15 68.8393 45 95.3571 60 101.25C75 95.3571 105 68.8393 105 45.2678C105 30.6241 92.913 18.75 78 18.75C67.431 18.75 58.437 24.7931 54 33.4821M93 45.2687C93 37.1307 86.286 30.5366 78 30.5366"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <defs>
            <linearGradient
                id="paint0_linear_20621_341935"
                x1="60"
                y1="18.75"
                x2="60"
                y2="101.25"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-opacity="0" />
                <stop offset="1" stop-color="#072B12" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "StylizedHeartIcon",
    props: {
        color: {
            type: String,
            default: "#1D2027",
        },
    },
});
</script>
